import { useEffect } from 'react';
import { getAndSelectProject } from 'store/services/project/actions';

const useProject = (params, dispatch) => {
  useEffect(() => {
    dispatch(getAndSelectProject(params.company, params.project));
  }, [params.company, params.project]);
};

export default useProject;
